import React from 'react';

/**
 * GarmentPanel – choose which garment to design.
 *
 * Props:
 *   garments   – GARMENTS
 *   selectedId – active garment slug
 *   onSelect   – (slug) => void
 */
export default function GarmentPanel({ garments, selectedId, onSelect }) {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <div style={{
                fontSize: '11px',
                color: '#888',
                textTransform: 'uppercase',
                letterSpacing: '1px',
                marginBottom: '4px',
            }}>
                Choose Garment
            </div>
            {garments.map((g) => {
                const isActive = g.slug === selectedId;
                return (
                    <button
                        key={g.slug}
                        onClick={() => onSelect(g.slug)}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '12px 8px',
                            background: isActive ? '#2a2a2a' : '#1a1a1a',
                            border: isActive ? '2px solid #ecff19' : '2px solid #333',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            transition: 'border-color 0.15s',
                            width: '100%',
                        }}
                    >
                        <img
                            src={g.multiply || g.background}
                            alt={g.name}
                            style={{
                                width: '80px',
                                height: '80px',
                                objectFit: 'contain',
                                display: 'block',
                                opacity: isActive ? 1 : 0.6,
                            }}
                        />
                        <span style={{
                            color: isActive ? '#ecff19' : '#aaa',
                            fontSize: '11px',
                            fontWeight: isActive ? 600 : 400,
                            textAlign: 'center',
                        }}>
                            {g.name}
                        </span>
                    </button>
                );
            })}
        </div>
    );
}
